import { createElementVNode as _createElementVNode, vModelText as _vModelText, withKeys as _withKeys, withDirectives as _withDirectives, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6bf82287"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "gamepass" }
const _hoisted_2 = { class: "gp-stack" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "gp-logo",
  src: "/logo.svg",
  alt: "Paladium"
}, null, -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "gp-head" }, [
  /*#__PURE__*/_createElementVNode("h1", { class: "gp-title" }, "Choisissez votre pseudo Minecraft"),
  /*#__PURE__*/_createElementVNode("p", { class: "gp-rule" }, "3 à 16 caractères : lettres, chiffres et _")
], -1))
const _hoisted_5 = { class: "gp-count" }
const _hoisted_6 = {
  key: 0,
  class: "gp-error"
}
const _hoisted_7 = ["disabled"]
const _hoisted_8 = {
  key: 0,
  class: "ring-spinner",
  "aria-hidden": "true"
}
const _hoisted_9 = { key: 1 }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { id: "version" }, "Version 1.0.0", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _hoisted_4,
      _createElementVNode("div", {
        class: _normalizeClass(["gp-field", { 'is-valid': _ctx.isValid && !_ctx.displayError, 'is-invalid': !!_ctx.displayError }])
      }, [
        _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.pseudonyme) = $event)),
          type: "text",
          placeholder: "Votre pseudo",
          maxlength: "16",
          onKeyup: _cache[1] || (_cache[1] = _withKeys(
//@ts-ignore
(...args) => (_ctx.gamepass && _ctx.gamepass(...args)), ["enter"]))
        }, null, 544), [
          [_vModelText, _ctx.pseudonyme]
        ]),
        _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.pseudonyme.length) + "/16", 1)
      ], 2),
      (_ctx.displayError)
        ? (_openBlock(), _createElementBlock("p", _hoisted_6, _toDisplayString(_ctx.displayError), 1))
        : _createCommentVNode("", true),
      _createElementVNode("button", {
        type: "button",
        class: "gp-submit",
        disabled: _ctx.ingamepass || !_ctx.isValid,
        onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.gamepass && _ctx.gamepass(...args)))
      }, [
        (_ctx.ingamepass)
          ? (_openBlock(), _createElementBlock("span", _hoisted_8))
          : (_openBlock(), _createElementBlock("span", _hoisted_9, "Valider"))
      ], 8, _hoisted_7)
    ]),
    _createElementVNode("a", {
      id: "help-link",
      href: "#",
      onClick: _cache[3] || (_cache[3] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.goBack && _ctx.goBack(...args)), ["prevent"]))
    }, "‹ Retour à la connexion"),
    _hoisted_10
  ]))
}